<p-dialog
  header="Add New Item to Quote"
  [modal]="true"
  [visible]="visible"
  [style]="{
    width: '85vw',
    height: '80vh',
    display: 'flex',
    'flex-direction': 'column',
  }"
  [contentStyle]="{
    display: 'flex',
    'flex-direction': 'column',
    flex: '1 1 auto',
    'min-height': '0',
    overflow: 'hidden',
  }"
  [appendTo]="'body'"
  [dismissableMask]="false"
  [closable]="!isSubmitting"
  [closeOnEscape]="!isSubmitting"
  (visibleChange)="onVisibleChange($event)"
  (onShow)="onDialogShow()"
  (onHide)="closeDialog()"
>
  <div class="min-h-0 flex-1 overflow-y-auto">
    <div
      [class.opacity-40]="isSubmitting"
      [class.pointer-events-none]="isSubmitting"
    >
      <app-quote-item-data-editor
        [allBlueprints]="allBlueprints"
        [currencyCode]="dialogCurrencyCode"
        [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
        [pdfDrawingUploadEnabled]="pdfDrawingUploadEnabled"
        [equipmentOptions]="equipmentOptions"
        [consumablesEnabled]="consumablesEnabled"
        [consumableOptions]="consumableOptions"
      />
    </div>
  </div>
  <ng-template #footer>
    <div class="flex w-full flex-col gap-2">
      @if (submitError) {
        <p-message severity="error" styleClass="w-full">
          {{ submitError }}
        </p-message>
      }
      <div class="flex w-full items-center justify-between gap-2">
        @if (isSubmitting) {
          <span aria-live="polite" class="text-sm text-surface-switch-600">
            Creating quote items…
          </span>
        }
        <div class="flex gap-2 ml-auto">
          <p-button
            label="Cancel"
            severity="secondary"
            (click)="closeDialog()"
            [disabled]="isSubmitting"
          />
          <p-button
            label="Add to Quote"
            icon="pi pi-check"
            severity="primary"
            (click)="onSubmitItemTree()"
            [disabled]="
              isSubmitting || !quoteItemDataEditorService.items().length
            "
            styleClass="min-w-[10rem]"
          />
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
